import { useTranslation } from "react-i18next";
import ReactCountryFlag from "react-country-flag";

import { Button } from 'primereact/button';

import './menu.css'

export default function TopMenu() {

    const { i18n } = useTranslation();
    const currentLang = i18n.language;

    return(
        <div className="topmenu">
            <div className="start">
                <div className="logo">
                    <h3 className="ml-4">Cédric Jeanjean</h3>
                </div>
            </div>
            <div className="absolute right-0">
                <Button onClick={() => i18n.changeLanguage("fr")} title="Français" className={`lang-btn ${currentLang === "fr" ? "active" : "inactive"} p-0 border-none mr-2`} outlined>
                    <ReactCountryFlag
                        svg
                        countryCode="FR"
                        style={{
                        width: "1.5em",
                        height: "1.5em"
                        }}
                    />
                </Button>

                <Button onClick={() => i18n.changeLanguage("en")} title="English"  className={`lang-btn ${currentLang === "en" ? "active" : "inactive"} p-0 border-none mr-2`} outlined>
                    <ReactCountryFlag
                        svg
                        countryCode="GB"
                        style={{
                        width: "1.5em",
                        height: "1.5em"
                        }}
                    />
                </Button>
            </div>
        </div>
    )
}